import { render, staticRenderFns } from "./CompanyDetailTenantTable.vue?vue&type=template&id=5a0fe2b0&scoped=true&"
import script from "./CompanyDetailTenantTable.vue?vue&type=script&lang=ts&"
export * from "./CompanyDetailTenantTable.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyDetailTenantTable.vue?vue&type=style&index=0&id=5a0fe2b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0fe2b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
